import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import HeaderStats from "components/Headers/HeaderStats.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";

// views
import Dashboard from "views/admin/Dashboard.js";
import Maps from "views/admin/Maps.js";
import Settings from "views/admin/Settings.js";
import Tables from "views/admin/Tables.js";
import GetVendors from "components/Tables/GetVendors";
import GetEmployee from "components/Tables/GetEmployee";
import GetService from "components/Tables/GetService"
import GetUser from "components/Tables/GetUser"
import GetContact from "components/Tables/GetContact";
import AddCity from "components/Forms/AddCity";
import AddCategory from "components/Forms/AddCategory";
import AddRatecard from "components/Forms/AddRatecard";
import AdminLogin from "components/Forms/AdminLogin";


import ProtectedRoute from "components/Routes/ProtectedRoute";
import GetCity from "components/Tables/GetCity";
import GetRateCard from "components/Tables/GetRateCard";
import GetCategory from "components/Tables/GetCategory";
import AddService from "components/Forms/AddService";
import AdminUpdate from "components/Forms/AdminUpdate";
import EditService from "components/Forms/EditService";
import EditCategory from "components/Forms/EditCategory";
import EditRateCard from "components/Forms/EditRateCard";
import GetBooking from "components/Tables/GetBooking";
import GetTaskEmp from "components/Tables/GetviewTask";
import Poster from "components/Tables/Poster";
import Notifications from "components/Tables/Notifications";
import Subscription from "components/Tables/Subscription";
import NotificationHistory from "components/Tables/GetnotificationHistory";
import UpdateSubscription from "components/Tables/UpdateSubscription";
import ChangePassword from "components/Forms/ChangePassword";
import UseApp from "components/Forms/UseApp";
import UseAppEmployee from "components/Forms/UseAppEmployee";


export default function Admin() {
  return (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-blueGray-100">
        <AdminNavbar />
        <HeaderStats />
        <div className="px-4 md:px-10 mx-auto w-full -m-24">
          <Routes>
            <Route path="/" element={<AdminLogin />} />
            <Route path="dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="maps" element={<Maps />} />
            <Route path="settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="vendor" element={<ProtectedRoute><GetVendors /></ProtectedRoute>} />
            <Route path="booking" element={<ProtectedRoute><GetBooking /></ProtectedRoute>} />
            <Route path="employee" element={<ProtectedRoute><GetEmployee /></ProtectedRoute>} />
            <Route path="user" element={<ProtectedRoute><GetUser /></ProtectedRoute>} />
            <Route path="ratecard" element={<ProtectedRoute><GetRateCard /></ProtectedRoute>} />
            <Route path="city" element={<ProtectedRoute><GetCity /></ProtectedRoute>} />
            <Route path="category" element={<ProtectedRoute><GetCategory /></ProtectedRoute>} />
            <Route path="contact" element={<ProtectedRoute><GetContact /></ProtectedRoute>} />
            <Route path="service" element={<ProtectedRoute><GetService /></ProtectedRoute>} />
            <Route path="addcity" element={<ProtectedRoute><AddCity /></ProtectedRoute>} />
            <Route path="addservice" element={<ProtectedRoute><AddService /></ProtectedRoute>} />
            <Route path="addcategory" element={<ProtectedRoute><AddCategory /></ProtectedRoute>} />
            <Route path="addratecard" element={<ProtectedRoute><AddRatecard /></ProtectedRoute>} />
            <Route path="editservice/:id" element={<ProtectedRoute><EditService /></ProtectedRoute>} />
            <Route path="editcategory/:id" element={<ProtectedRoute><EditCategory /></ProtectedRoute>} />
            <Route path="editratecard/:id" element={<ProtectedRoute><EditRateCard /></ProtectedRoute>} />
            <Route path="update" element={<ProtectedRoute><AdminUpdate /></ProtectedRoute>} />
            <Route path="poster" element={<ProtectedRoute><Poster /></ProtectedRoute>} />
            <Route path="notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
            <Route path="notificationhistory" element={<ProtectedRoute><NotificationHistory /></ProtectedRoute>} />
            <Route path="subscription" element={<ProtectedRoute><Subscription /></ProtectedRoute>} />
            <Route path="addsubscription" element={<ProtectedRoute><UpdateSubscription /></ProtectedRoute>} />
            <Route path="change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
            <Route path="useApp" element={<ProtectedRoute><UseApp /></ProtectedRoute>} />
            <Route path="useAppEmployee" element={<ProtectedRoute><UseAppEmployee /></ProtectedRoute>} />
            {/* <Route path="gettaskemp/:empId" element={<GetTaskEmp />} /> */}
            <Route path="tables" element={<Tables />} />
            {/* Redirect /admin to /admin/dashboard */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <FooterAdmin />
        </div>
      </div>
    </>
  );
}
